import React, { memo, useEffect, useRef, useState } from 'react';
import { View, Platform, SafeAreaView } from 'react-native';
import WebView from 'react-native-webview';
import { useDispatch, useSelector } from 'react-redux';
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import Loader from '../../components/Loader/loader';
import { getCleanUrl } from '../../utils/Helper';
import { handleMessageEventListener } from '../../js/iFrameEventListener';
import { useNavigation } from '@react-navigation/native';

const IFrameViewer = () => {
  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const navigate = useNavigation();


  const widgetData = useSelector(
    state => state.deviceConfigSlice?.currentWidget,
  );

  const [loading, setLoading] = useState(true);
  const cleanedUrl = getCleanUrl(widgetData?.targetUrl);
  const [url, setUrl] = useState(cleanedUrl);

  const webViewRef = useRef();
  const iframeRef = useRef();

  useEffect(() => {
    if (Platform.OS === 'web') {
      const handleMessage = (event) => {
        dispatch(handleMessageEventListener(event, iframeRef, navigate));
      };

      window.addEventListener('message', handleMessage);
      setTimeout(() => {
        setLoading(false);
      }, 900);


      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <View
      style={[
        getStyles(['widgetRootContainer', 'iFrameRootContainer'])
      ]}
      id="widgetRootContainer iFrameRootContainer">
      <HeaderWithBack />
      <View
        style={getStyles(['widgetmainContainer', 'iFrameMainContainer'])}
        id="widgetmainContainer iFrameMainContainer">

        {loading && (
          <>
            <View style={{ height: "100%", justifyContent: "center", alignItems: "center" }}>
              <Loader style={getStyles(['crossOverContaniner_loader'])} />
            </View>
          </>
        )}
        {Platform.OS === 'web' ? (
          <iframe
            ref={iframeRef}
            src={url}
            style={getStyles([
              'widgetmainContainerChildContainer',
              'iFrameMainContainerChildContainer',
              `iFrame_${widgetData?.widgetMetaHtmlId}`,
            ])}
            title={widgetData?.displayName}
            onLoad={() => setLoading(false)}
          />
        ) : (
          <WebView
            ref={webViewRef}
            originWhitelist={['*']}
            style={getStyles([
              'widgetmainContainerChildContainer',
              'webViewMainContainerChildContainer',
              `webView_${widgetData?.widgetMetaHtmlId}`
            ])}
            source={{ uri: url }}
            javaScriptEnabled={true}
            allowsInlineMediaPlayback={true}
            allowsFullscreenVideo={false}
            

            cacheEnabled={true}
            onLoadEnd={() => setLoading(false)}
            onMessage={(event)=> dispatch(handleMessageEventListener(event, webViewRef, navigate))}
          />
        )}
      </View>
    </View>
  );
};

export default memo(IFrameViewer);